import useRevalidateFileDetail from '@/modules/FileDetail/hooks/useRevalidateFileDetail';
import { sendToBranchActionMutationFn } from '@/modules/FileDetail/queries/sendActions/sendToBranchAction/sendToBranchActionMutationFn';
import { SendToBranchActionMutationDataType } from '@/modules/FileDetail/queries/sendActions/sendToBranchAction/sendToBranchActionMutationFn.types';
import { useMutation } from '@tanstack/react-query';

const useSendToBranchActionMutation = (id: string) => {
  const { revalidateFileDetail } = useRevalidateFileDetail(id);

  return useMutation({
    mutationFn: (data: SendToBranchActionMutationDataType) =>
      sendToBranchActionMutationFn(data, id),
    meta: {
      successToast: 'اقدام با موفقیت انجام شد',
    },
    onSuccess: () => {
      return revalidateFileDetail();
    },
  });
};

export default useSendToBranchActionMutation;
